import { render } from "./DropdownMenu.vue?vue&type=template&id=582a11a6&scoped=true&ts=true"
import script from "./DropdownMenu.vue?vue&type=script&lang=ts"
export * from "./DropdownMenu.vue?vue&type=script&lang=ts"

import "./DropdownMenu.vue?vue&type=style&index=0&id=582a11a6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582a11a6"]])

export default __exports__